export function hasValidSearch({ delta_days, count_guests }) {
  return Boolean(delta_days && count_guests);
}

export function isDirectTariffSource(tariffSource) {
  return !tariffSource || tariffSource === 'mt';
}

export function getDisplayedFoodAndTariff({
  apartment,
  selectedTariff,
  foodTypeName,
  tariffCondition,
  delta_days,
  count_guests,
  tariffSource,
}) {
  if (hasValidSearch({ delta_days, count_guests })) {
    const tariffName = selectedTariff?.tariff_condition_name || tariffCondition || null;
    const foodName = selectedTariff?.food_name_for_food_filter || selectedTariff?.food_name || 'Без питания';

    return {
      foodName,
      tariffName,
    };
  }

  return {
    foodName: foodTypeName ?? apartment?.price_min_food_name ?? null,
    tariffName: tariffCondition ?? apartment?.price_min_tariff_name ?? null,
  };
}
